export const myDownload = {
    path: '/myDownload',
    name: 'myDownload',
    title: '我的下载',
    component: () => import("../components/page/myDownload/myDownload"),
    meta:{title:'我的下载'}
}


// WEBPACK FOOTER //
// ./src/router/myDownload.js